import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './design-system.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const isProduction = process.env.NODE_ENV === 'production';

Sentry.init({
  dsn: "https://2afbe975f8d4e935fdbc5b2fc04dfb23@o4510811359215616.ingest.de.sentry.io/4510868614152272",
  environment: process.env.NODE_ENV,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Sample 10% of traces in production (full sampling at 1.0 is costly and noisy); full in dev.
  tracesSampleRate: isProduction ? 0.1 : 1.0,
  replaysSessionSampleRate: isProduction ? 0.05 : 0,
  replaysOnErrorSampleRate: 1.0,
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/vgszqmsmjrtgaytueerf\.supabase\.co/,
    /^https:\/\/proxy-five-kappa-79\.vercel\.app/,
  ],
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(); 